module.exports = __webpack_public_path__ + "img/Skirt-Front-B1-Da-Fb-Gc-Hc-Ia.c272f499.png";